<script lang="ts" setup>
	import StringMethods from '~/utils/character'
	import type { ListContext as CentralListContext } from '~/types'
	export type ListContext = CentralListContext

	defineProps<{
		lists: ListContext
		liClass?: ClassContext
		pClass?: ClassContext
		hClass?: ClassContext
		ulClass?: ClassContext
		loading?: boolean
	}>()
	const { stripUnderScore } = StringMethods()
</script>

<template>
	<div>
		<loader-skeleton v-if="loading" :count="1" :height="200" class-list="w-full" :max-width="false" />
		<ul v-else :class="cn('w-full px-3 py-5 md:px-6', ulClass)">
			<li class="w-full">
				<slot name="prepend" />
			</li>
			<li
				v-for="(v, k) in lists"
				:key="k"
				:class="
					cn('flex-wrap items-center justify-between gap-x-4 gap-y-2 border-b', [
						!lists[k] || (typeof v === 'object' && v?.disabled)
							? 'hidden'
							: (typeof v === 'object' && v?.wrapperClass) || 'flex',
						liClass || 'py-5 text-base'
					])
				"
			>
				<span
					:class="cn('font-medium capitalize text-gray-500', hClass, typeof v === 'object' && v?.hClass)"
					v-html="stripUnderScore(k as string)"
				/>
				<slot :value="v" :ke="k">
					<span
						:class="cn('font-semibold', pClass, typeof v === 'object' && v?.pClass)"
						v-html="typeof v === 'object' ? v?.value : v"
					/>
				</slot>
			</li>
		</ul>
	</div>
</template>
